import INavigationItem from "../models/INavigationItem";

const navigationItems: INavigationItem[] = [
    {
        text: 'Home',
        active: true
    },
    {
        text: 'Find a doctor',
    },
    {
        text: 'Apps',
    },
    {
        text: 'Testimonials',
    },
    {
        text: 'About us',
    },
];


export default navigationItems;